<template>
<div>

</div>
</template>

<script>
export default {
    mounted () {
         this.$router.replace({
                'name': 'ios-launcher',
            }).catch(e=>{}); // swallow any exception
    },
}
</script>

<style lang="scss" scoped>

</style>